const BLOCKED_KEYWORDS = [
  "instagram", "facebook", "youtube", "youtu.be", "twitter", "tiktok",
  "whatsapp", "telegram", "snapchat", "linkedin", "pinterest", "threads",
  "www.", "http://", "https://",
];

const TLD_PATTERN = /\b[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.(com|in|net|org|co|io|shop|store|biz|info|me|xyz|online|app|dev|us|uk|ca|au|de|store|link)\b/i;

// A "run" is any block of digits/spaces/dashes/parens with no letters or
// commas breaking it up — letters already end a run on their own, so
// alphanumeric postal codes (UK "SW1A 1AA", Canada "1A1 235") never reach
// this check at all. This only matters for pure-digit formats.
//
// Threshold is raw-digit count within that run, not string length:
//   - India PIN (6), Brazil CEP (8, "12345-678"), US ZIP+4 (9,
//     "12345-6789") all pass.
//   - A phone number written as one connected block (e.g. India's
//     9876543210, or "123-456-7890") is reliably 10 digits and gets
//     blocked.
const DIGIT_RUN = /[\d][\d\s\-()]{5,}[\d]/g;
const PHONE_DIGIT_THRESHOLD = 10;

export function findAddressViolation(rawAddress) {
  const address = (rawAddress || "").trim();
  if (!address) return null;

  const lower = address.toLowerCase();
  for (const kw of BLOCKED_KEYWORDS) {
    if (lower.includes(kw)) {
      return `Please remove "${kw}" — links and social handles aren't allowed here.`;
    }
  }

  if (TLD_PATTERN.test(address)) {
    return "Please remove website links from the address field.";
  }

  if (/[<>]/.test(address)) {
    return "The characters < and > aren't allowed in the address field.";
  }

  const runs = address.match(DIGIT_RUN) || [];
  for (const run of runs) {
    if ((run.match(/\d/g) || []).length >= PHONE_DIGIT_THRESHOLD) {
      return "Please remove phone numbers — postal/PIN codes up to 9 digits are fine.";
    }
  }

  return null;
}
